module.exports = __webpack_public_path__ + "statics/img/cate.ba7b57ef.png";